import { render } from "./error-comp.vue?vue&type=template&id=10003d6c&scoped=true"
import script from "./error-comp.vue?vue&type=script&lang=js"
export * from "./error-comp.vue?vue&type=script&lang=js"

import "./error-comp.vue?vue&type=style&index=0&id=10003d6c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10003d6c"]])

export default __exports__